import React, {useEffect} from 'react';
import { connect } from "react-redux";

import { AppstoreOutlined } from '@ant-design/icons';

import { Popover } from "antd";
import {PROJECT_BUILD_VERSION} from "../../utils/constants";

import {getBackInfo} from "../../store/project-info/actions";

const Description = (props)=> {
  const {getBackInfo} = props;

  useEffect(()=>{
    getBackInfo()
  },[getBackInfo])

    return (
      <div id='global'>
        <Popover
          content={
            <div className='global-info'>
              <table>
                <tbody>
                <tr>
                  <td>
                    Frontend
                  </td>
                  <td>
                    version: {PROJECT_BUILD_VERSION}
                  </td>
                </tr>
                <tr>
                  <td>
                    Backend
                  </td>
                  <td>
                    <div>
                      commit: {props.backInfo && props.backInfo.payload && props.backInfo.payload.data && props.backInfo.payload.data.commit}
                    </div>
                    <div>
                      version: {props.backInfo && props.backInfo.payload && props.backInfo.payload.data &&  props.backInfo.payload.data.version}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          }>
          <AppstoreOutlined />
        </Popover>
      </div>
    );
}

function mapStateToProps(state) {
  return {
    backInfo: state.backInfo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getBackInfo: ()=> dispatch(getBackInfo()),
  };
}

export const ProjectDescription = connect(mapStateToProps, mapDispatchToProps)(Description);
